import { useAtomValue } from "jotai";
import type { FunctionComponent, ReactNode } from "react";
import { useEffect } from "react";
import { graphql, useFragment } from "react-relay";

import { rosettaAtom } from "~/lib/rosetta";
import type { articlePaywallCheckerContent$key } from "~/queries/__generated__/articlePaywallCheckerContent.graphql";

import { usePaywallPromise } from "./hooks";

type Props = {
  children?: ReactNode;
  reference: articlePaywallCheckerContent$key;
};

export const ArticlePaywallChecker: FunctionComponent<Props> = ({ children, reference }) => {
  const asyncRosettaState = useAtomValue(rosettaAtom);
  const content = useFragment(
    graphql`
      fragment articlePaywallCheckerContent on Content {
        ...hooksPaywallPromiseContent
      }
    `,
    reference,
  );

  const isShowInlinePaywall = usePaywallPromise(content);

  useEffect(() => {
    if (!isShowInlinePaywall || asyncRosettaState?.status === "loading") return;
    // TODO: handle show inline paywall offer at here
    // Mainly for tracking
  }, [asyncRosettaState?.status, isShowInlinePaywall]);

  if (!children || isShowInlinePaywall) return null;
  return <>{children}</>;
};

ArticlePaywallChecker.displayName = "ArticlePaywallChecker";
